"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// @ts-ignore
import assert from "@charlesderek/assert";
import "./youtubeAlarm.css";
import { notifyUpdate, debugLog } from "./index";
import { AsyncState } from "../../../../tab-utils/AsyncState";
export { youtubeStart, youtubeStop, youtubeIsPlaying, youtubeSetUrl, youtubeNoUrl, youtubePrefetch };
var YOUTUBE_WRAPPER_ID = "youtube_wrapper";
var YOUTUBE_IFRAME_ID = "youtube_iframe";

var _ref = new AsyncState({
  isStarted: false,
  youtubeUrl: "",
  prefetchEnabled: false
}, update),
    state = _ref.state;

function youtubeStart() {
  state.isStarted = true;
}

function youtubeStop() {
  state.isStarted = false;
}

function youtubeNoUrl() {
  return state.youtubeUrl === "";
}

function youtubeSetUrl(youtubeUrl) {
  state.youtubeUrl = youtubeUrl; // User has changed the theme or the youtube alarm
  // Update the whole notification logic

  notifyUpdate();
}

function youtubePrefetch() {
  state.prefetchEnabled = true;
}
/*
youtubeDisabled
function neverPlayedBefore() {
  // Was the playing state was ever achieved?
  // If not, the prefetching didn't work (/happened yet)
  return stateChanges.includes(1);
}
*/


function update(isNotLastUpdate) {
  assert(state.youtubeUrl.constructor === String);

  if (!state.isStarted) {
    stop(isNotLastUpdate);

    if (state.youtubeUrl && state.prefetchEnabled) {
      prefetch(isNotLastUpdate);
    }
  }

  if (state.youtubeUrl !== "" && state.isStarted) {
    start(isNotLastUpdate);
  }
}

function start(_x) {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isNotLastUpdate) {
    var player;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            debugLog("[youtube] start youtube alarm (attempt)");
            _context.next = 3;
            return load_player();

          case 3:
            player = _context.sent;

            if (!isNotLastUpdate()) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            playerStart(player);
            document.querySelector("#" + YOUTUBE_WRAPPER_ID).classList.add("youtube_alarm_show");
            debugLog("[youtube] start youtube alarm (success)");

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _start.apply(this, arguments);
}

function playerStart(player) {
  loadVideo(player);
  player.unMute(); // player.setLoop(true);
}

function stop(_x2) {
  return _stop.apply(this, arguments);
}

function _stop() {
  _stop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(isNotLastUpdate) {
    var player;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            debugLog("[youtube] stop youtube alarm (attempt)");
            _context2.next = 3;
            return load_player();

          case 3:
            player = _context2.sent;

            if (!isNotLastUpdate()) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return");

          case 6:
            document.querySelector("#" + YOUTUBE_WRAPPER_ID).classList.remove("youtube_alarm_show");
            playerStop(player);
            debugLog("[youtube] stop youtube alarm (success)");

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _stop.apply(this, arguments);
}

function playerStop(player) {
  player.mute(); // player.setLoop(false);
}

var lastPrefetch;

function prefetch(_x3) {
  return _prefetch.apply(this, arguments);
}

function _prefetch() {
  _prefetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(isNotLastUpdate) {
    var player;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            debugLog("[youtube] prefetching (attempt)");
            _context3.next = 3;
            return load_player();

          case 3:
            player = _context3.sent;

            if (!isNotLastUpdate()) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            if (!(lastPrefetch === state.youtubeUrl)) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return");

          case 8:
            player.mute(); // player.setLoop(false);

            loadVideo(player);
            lastPrefetch = state.youtubeUrl;
            debugLog("[youtube] prefetching (success)");

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _prefetch.apply(this, arguments);
}

var loadedVideoId;

function loadVideo(player) {
  var _parse_youtube_url = parse_youtube_url(state.youtubeUrl),
      video_id = _parse_youtube_url.video_id,
      video_start = _parse_youtube_url.video_start;

  if (video_id !== loadedVideoId) {
    loadedVideoId = video_id;
    player.loadVideoById({
      videoId: video_id,
      startSeconds: video_start
    });
  } else {
    player.seekTo(video_start);
    player.playVideo();
  }
}

var player__loaded;
var player__promise;

function load_player() {
  return _load_player.apply(this, arguments);
}

function _load_player() {
  _load_player = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var resolve;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!player__loaded) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", player__loaded);

          case 2:
            if (!player__promise) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", player__promise);

          case 4:
            player__promise = new Promise(function (r) {
              return resolve = r;
            });
            window.onYouTubeIframeAPIReady = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
              var player;
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      player = new window.YT.Player(YOUTUBE_IFRAME_ID, {
                        events: {
                          onReady: function onReady() {
                            player__loaded = player;
                            resolve(player__loaded);
                          },
                          onStateChange: onStateChange
                        },
                        height: "150",
                        width: "300",
                        playerVars: {
                          controls: 0,
                          modestbranding: 1,
                          rel: 0,
                          color: "white"
                        }
                      });

                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));
            load_script("https://www.youtube.com/iframe_api");
            return _context5.abrupt("return", player__promise);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _load_player.apply(this, arguments);
}

var stateChanges;

function onStateChange(event) {
  // `event.data` possible values:
  // -1 – unstarted
  //  0 – ended
  //  1 – playing
  //  2 – paused
  //  3 – buffering
  //  5 – video cued
  var state = event.data;
  stateChanges = stateChanges || [];
  stateChanges.push(state);
  var time = new Date().toTimeString().split(" ")[0];
  debugLog("[youtube] player state: ".concat(state, " (").concat(time, ")"));
}

function youtubeIsPlaying() {
  // Ignoring buffering state, is the last state is playing, then `return true`
  for (var i = (stateChanges || []).length - 1; i >= 0; i--) {
    var stateChange = stateChanges[i]; // Playing

    if (stateChange === 1) {
      return true;
    } // Buffering


    if (stateChange === 3) {
      continue;
    }

    return false;
  }

  return false;
}

function parse_youtube_url(url) {
  assert(url.constructor === String); //sanetize URL

  url = url.replace(" ", ""); //retrieve ID

  var video_id = url_to_id(url);
  assert(video_id || video_id === null); //retrieve start & repeat

  var matches = /(?:\?|&)(?:start|t)=([^&#]*)/.exec(url);
  var video_start = matches ? parseInt(matches[1], 10) : 0; //video_repeat_=/(?:\?|&)(repeat|loop)/.test(url);

  var video_repeat = /repeat|replay|loop/.test(url);
  return {
    video_start: video_start,
    video_id: video_id,
    video_repeat: video_repeat
  };
}

function url_to_id(url) {
  //ID chars: /[a-zA-Z0-9-_]+/ --http://stackoverflow.com/questions/830596/what-type-of-id-does-youtube-use-for-their-videos
  //var matches=/youtube\.com.*(?:\?|&)v=([^&#]+)/.exec(url);
  var matches = /youtube\.com.*(?:\?|&)v=([a-zA-Z0-9\-_]+)/.exec(url) || /youtu.be\/([a-zA-Z0-9\-_]+)/.exec(url);
  return matches ? matches[1] : null;
}

function load_script(url) {
  var scriptEl = document.createElement("script");
  scriptEl.src = url;
  scriptEl.async = true;
  var resolve;
  var promise = new Promise(function (r) {
    return resolve = r;
  });

  scriptEl.onload = function () {
    resolve();
  };

  document.getElementsByTagName("head")[0].appendChild(scriptEl);
  return promise;
}